export var ConditionCombine;
(function (ConditionCombine) {
    ConditionCombine[ConditionCombine["None"] = 0] = "None";
    ConditionCombine[ConditionCombine["And"] = 1] = "And";
    ConditionCombine[ConditionCombine["Or"] = 2] = "Or";
})(ConditionCombine || (ConditionCombine = {}));
